import Coin from "./game/entities/Coin";
import Player from "./game/entities/Player";
import { crazygamesSDK, InviteParams } from "./crazygames/sdk";
import { getAdblockStatus, isAdScriptBlocked } from "./crazygames/adblock";

export function random(min: number, max: number) {
  return min + (Math.random() * (max - min));
}

export function isObject(item: any) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export function mergeDeep(target: any, ...sources: any): any {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) target[key] = {};
        mergeDeep(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export function mergeDeepInto(target: any, source: any): any {
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) target[key] = {};
        mergeDeepInto(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  return target;
}

export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function secondsToTime(duration: number) {
  const portions = [];

  const secInHour = 60 * 60;
  const hours = Math.trunc(duration / secInHour);
  if (hours > 0) {
    portions.push(hours + 'h');
    duration = duration - (hours * secInHour);
  }

  const secInMinute = 60;
  const minutes = Math.trunc(duration / secInMinute);
  if (minutes > 0) {
    portions.push(minutes + 'm');
    duration = duration - (minutes * secInMinute);
  }

  const seconds = Math.trunc(duration);
  if (seconds > 0) {
    portions.push(seconds + 's');
  }

  return portions.join(' ');
}

function humanReadable(seconds: number) {
  const timeUnits: any = [
    [60, 'seconds'],
    [60, 'minutes'],
    [24, 'hours'],
    [365, 'days'],
    [Infinity, 'years'],
  ];

  let unitIndex = 0;
  let time = seconds;

  while (time >= timeUnits[unitIndex][0] && unitIndex < timeUnits.length - 1) {
    time /= timeUnits[unitIndex][0];
    unitIndex++;
  }

  time = Math.floor(time);
  const unitName = timeUnits[unitIndex][1];
  return `${time} ${time === 1 ? unitName.slice(0, -1) : unitName}`;
}

export function sinceFrom(dateString: string) {
  const pastDate = new Date(dateString).getTime();
  const now = new Date().getTime();
  const secondsDiff = Math.floor((now - pastDate) / 1000);
  return humanReadable(secondsDiff);
}

export function fixDate(inputDate: Date) {
  // https://stackoverflow.com/a/14569783
  // return  new Date( inputDate.getTime() + Math.abs(inputDate.getTimezoneOffset()*60000) )
  return inputDate;
}

export function lastSeen(dateString: string) {
  if (!dateString) return 'never';

  const inputDate = new Date(dateString);
  const now = new Date();

  const diffMs = now.getTime() - inputDate.getTime();
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec < 600) {
    return 'now';
  }

  return humanReadable(diffSec) + ' ago';
}


export function addCommas(num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function calculateGemsXP(coins: number, kills: number, tokens: number) {
  const xp = Math.floor(coins / 20) + (kills * 50)
  if (coins >= 1250000) {
    return {
      xp,
      gems: Math.floor(xp / 5),
      mastery: Math.floor((coins / 794) ** 1.5), 
      tokens: tokens,
    };
  } else {
    return {
      xp,
      gems: Math.floor(xp / 5),
      mastery: Math.floor((coins / 5000) ** 2),
      tokens: tokens,
    };
  }
}

export function buyFormats(amount: number) {

  if(amount === 0) return '0';

  const values = ['<3', '<5', '<10', '10+', '20+', '30+', '40+', '50+', '60+', '70+', '80+', '90+', '100+', '200+', '300+', '400+', '500+', '600+', '700+', '800+', '900+', '1K+', '2K+', '3K+', '4K+', '5K+', '6K+', '7K+', '8K+', '9K+', '10K+', '15K+', '71K+', '72K+', '73K+', '74K+', '75K+'];

  const amountToNumber = (val: string) => {
    const num = parseFloat(val.replace(/[<+KM]/g, ''));
    return val.includes('M') ? num * 1000000 : val.includes('K') ? num * 1000 : num;
  };

  for (let i = 0; i < values.length; i++) {
    const current = values[i];
    const next = i + 1 < values.length ? values[i + 1] : null;

    const currentVal = amountToNumber(current);
    const nextVal = next ? amountToNumber(next) : Infinity;

    if ((current.includes('<') && amount < currentVal) ||
        (!current.includes('<') && amount >= currentVal && amount < nextVal)) {
      return current;
    }
  }

  return values[values.length - 1];
}

export function getCookies() {
  const cookies: any = {};
  document.cookie.split(';').forEach((cookie) => {
    const [key, value] = cookie.split('=');
    cookies[key.trim()] = value;
  });
  return cookies;
}

export function findCoinCollector(coin: Coin, players: Player[]) {
    const errorThreshold = 1.1;
    const coinRadius = coin.shape.radius * coin.container.scale * errorThreshold;
    const coinX = coin.shape.x;
    const coinY = coin.shape.y;

    let entity = null;
    players.forEach((player: Player) => {
      const playerRadius = player.shape.radius * 2 * errorThreshold;
      if (playerRadius > coinRadius) {
        const distance = Math.sqrt(Math.pow(player.shape.x - coinX, 2) + Math.pow(player.shape.y - coinY, 2));
        if (distance < playerRadius) {
          entity = player;
        }
      }
    });
    return entity;
}



export function isAdBlockActive(): boolean {
  const w = window as any;
  if (w._isCrazyGamesBasicLaunch) return false;
  return getAdblockStatus() || isAdScriptBlocked();
}


const adMaxWaitMs = 60000;
const rewardedFastFailMs = 3000;
const breakStartMs = 8000;

let pendingRewardRelease: (() => void) | null = null;

function setVideoAdActive(w: any, active: boolean) {
  w.videoAdActive = active;
}

function releasePendingReward() {
  const release = pendingRewardRelease;
  pendingRewardRelease = null;
  if (release) release();
}

let aipPending: ((evt: string) => void) | null = null;

function aipSettle(evt: string) {
  const cb = aipPending;
  aipPending = null;
  if (cb) cb(evt);
}

function ensureAipPlayer(w: any): boolean {
  const existing = w.aiptag?.adplayer;
  if (existing && typeof existing.startPreRoll === 'function') return true;
  if (typeof w.aipPlayer !== 'function') return false;
  w.aiptag.adplayer = new w.aipPlayer({
    AD_WIDTH: 960,
    AD_HEIGHT: 540,
    AD_FULLSCREEN: true,
    AD_CENTERPLAYER: false,
    LOADING_TEXT: 'loading advertisement',
    PREROLL_ELEM: function () { return document.getElementById('preroll'); },
    AIP_COMPLETE: (evt: any) => { console.log('[ads] preroll complete', evt); aipSettle(String(evt)); },
    AIP_REWARDEDGRANTED: (evt: any) => { console.log('[ads] rewarded granted', evt); aipSettle('rewarded-granted'); },
    AIP_REWARDEDNOTGRANTED: (evt: any) => { console.log('[ads] rewarded not granted', evt); aipSettle('rewarded-not-granted'); },
  });
  return typeof w.aiptag.adplayer?.startPreRoll === 'function';
}

function runAdsenseBreak(w: any, opts: { type: string; name: string }, done: (evt: string) => void) {
  if (typeof w.adBreak !== 'function') { done('no-provider'); return; }
  if (w.videoAdActive) { console.warn('[ads] an ad is already running'); done('video-ad-error'); return; }
  releasePendingReward();

  let settled = false;
  let started = false;
  const finish = (evt: string) => {
    if (settled) return;
    settled = true;
    clearTimeout(failsafe);
    clearTimeout(startTimer);
    setVideoAdActive(w, false);
    done(evt);
  };
  const failsafe = setTimeout(() => finish('video-ad-timeout'), adMaxWaitMs);
  const startTimer = setTimeout(() => { if (!started) finish('video-ad-notready'); }, breakStartMs);

  setVideoAdActive(w, true);

  const params: any = {
    type: opts.type,
    name: opts.name,
    beforeAd: () => { started = true; setVideoAdActive(w, true); },
    afterAd: () => { setVideoAdActive(w, false); },
    adBreakDone: (info: any) => {
      const status = (info && info.breakStatus) || 'unknown';
      finish(status === 'viewed' ? 'video-ad-completed' : 'video-ad-' + status);
    },
  };

  try {
    w.adBreak(params);
  } catch (e) {
    console.error('[ads] adBreak failed', e);
    finish('video-ad-error');
  }
}

export function isAdsenseProvider(): boolean {
  return (window as any)?.adProvider === 'adsense';
}

export function armAdsenseReward(handlers: {
  onOffer: (show: () => void) => void;
  onDone: (result: { success: boolean; evt: string }) => void;
}): () => void {
  const w = window as any;
  if (!isAdsenseProvider() || typeof w.adBreak !== 'function' || w.videoAdActive) {
    handlers.onDone({ success: false, evt: 'no-provider' });
    return () => {};
  }
  releasePendingReward();

  let done = false;
  let offered = false;
  let viewed = false;
  let shown = false;
  let adTimer: ReturnType<typeof setTimeout> | null = null;

  const settle = (result: { success: boolean; evt: string }) => {
    if (done) return;
    done = true;
    clearTimeout(offerTimer);
    if (adTimer) clearTimeout(adTimer);
    if (pendingRewardRelease === release) pendingRewardRelease = null;
    handlers.onDone(result);
  };
  const release = () => { settle({ success: false, evt: 'rewarded-superseded' }); };
  const offerTimer = setTimeout(() => {
    if (!offered) settle({ success: false, evt: 'rewarded-unavailable-notready' });
  }, breakStartMs);

  try {
    w.adBreak({
      type: 'reward',
      name: 'reward_2x_gems',
      beforeReward: (showAdFn: () => void) => {
        offered = true;
        clearTimeout(offerTimer);
        if (done) return;
        handlers.onOffer(() => {
          shown = true;
          setVideoAdActive(w, true);
          adTimer = setTimeout(() => settle({ success: false, evt: 'rewarded-timeout' }), adMaxWaitMs);
          try { showAdFn(); } catch (e) {
            setVideoAdActive(w, false);
            settle({ success: false, evt: 'rewarded-show-error' });
          }
        });
      },
      adViewed: () => { viewed = true; },
      adDismissed: () => { viewed = false; },
      afterAd: () => {
        setVideoAdActive(w, false);
        if (shown) settle({ success: viewed, evt: viewed ? 'rewarded-granted' : 'rewarded-dismissed' });
      },
      adBreakDone: (info: any) => {
        if (shown) setVideoAdActive(w, false);
        const status = (info && info.breakStatus) || 'unknown';
        if (viewed) settle({ success: true, evt: 'rewarded-granted' });
        else settle({ success: false, evt: (offered ? 'rewarded-' : 'rewarded-unavailable-') + status });
      },
    });
    pendingRewardRelease = release;
  } catch (e) {
    console.error('[ads] rewarded adBreak failed', e);
    settle({ success: false, evt: 'video-ad-error' });
  }

  return () => {
    if (pendingRewardRelease === release) pendingRewardRelease = null;
    done = true;
    clearTimeout(offerTimer);
  };
}

function runAdinplayAd(w: any, rewarded: boolean, done: (evt: string) => void, forcePreroll = false) {
  if (aipPending) { console.warn('[ads] an ad is already running'); done('video-ad-error'); return; }

  let settled = false;
  const finish = (evt: string) => {
    if (settled) return;
    settled = true;
    clearTimeout(failsafe);
    w.videoAdActive = false;
    if (rewarded) document.body.classList.remove('sb-rewarded-ad');
    done(evt);
  };
  const failsafe = setTimeout(() => {
    console.warn('[ads] adinplay ad timed out, unblocking UI');
    if (aipPending === finish) aipPending = null;
    finish('video-ad-timeout');
  }, adMaxWaitMs);

  aipPending = finish;
  w.videoAdActive = true;
  if (rewarded) document.body.classList.add('sb-rewarded-ad');

  w.aiptag.cmd.player.push(() => {
    try {
      if (!ensureAipPlayer(w)) { aipSettle('video-ad-error'); return; }
      const player = w.aiptag.adplayer;
      if (rewarded && !forcePreroll && typeof player.startRewardedAd === 'function') {
        player.startRewardedAd({ showLoading: true });
      } else {
        player.startPreRoll();
      }
    } catch (e) {
      console.error('[ads] adinplay ad failed to start', e);
      aipSettle('video-ad-error');
    }
  });
}

export const playVideoAd = (force = false) => {
  const windowAny = window as any;
  return new Promise<{ played: boolean; evt: string }>((resolve, reject) => {
  // basic launch
  if(crazygamesSDK.shouldUseSDK()) { resolve({ played: false, evt: 'cg-basic' }); return; }
  if(force || Date.now() - windowAny?.lastVidAdTime > windowAny?.vidAdDelay) {
    if (windowAny?.adProvider === 'adsense') {
      runAdsenseBreak(windowAny, { type: 'start', name: 'death_interstitial' }, (evt) => {
        console.log('[ads] adsense interstitial finished:', evt);
        const played = evt === 'video-ad-completed';
        if (played) {
          windowAny.lastVidAdTime = Date.now();
          try { window.localStorage.setItem('lastVidAdTime', windowAny.lastVidAdTime); } catch (e) {}
        }
        resolve({ played, evt });
      });
    // CrazyGames SDK
    } else if(windowAny?.adProvider === 'crazygames') {
      console.log('Playing video ad from CrazyGames');

      crazygamesSDK.requestAd('midgame', {
        adStarted: () => {
          console.log('[CrazyGames] Video ad started');
          const event = new CustomEvent('crazyGamesAdStarted');
          window.dispatchEvent(event);
        },
        adFinished: () => {
          console.log('[CrazyGames] Video ad finished');
          const event = new CustomEvent('crazyGamesAdFinished');
          window.dispatchEvent(event);
          resolve({ played: true, evt: 'video-ad-completed' });
        },
        adError: (error) => {
          console.log('[CrazyGames] Video ad error:', error);
          const event = new CustomEvent('crazyGamesAdFinished');
          window.dispatchEvent(event);
          resolve({ played: false, evt: 'video-ad-error' });
        }
      });
    } else if (windowAny?.adProvider === 'gamemonetize' && typeof windowAny.sdk !== 'undefined' && windowAny.sdk.showBanner !== 'undefined') {
    console.log('Playing video ad from gamemonetize');
    const sdk = windowAny.sdk;
    let gmSettled = false;
    const gmFailsafe = setTimeout(() => {
      if (gmSettled) return;
      gmSettled = true;
      resolve({ played: false, evt: 'gamemonetize-timeout' });
    }, adMaxWaitMs);
    const onComplete = () => {
      window.removeEventListener('gamemonetize_event_SDK_GAME_START', onComplete);
      if (gmSettled) return;
      gmSettled = true;
      clearTimeout(gmFailsafe);
      console.log('Ad complete');
      resolve({ played: true, evt: 'gamemonetize-complete' });
    };

    windowAny.lastVidAdTime = Date.now();
    window.localStorage.setItem('lastVidAdTime', windowAny.lastVidAdTime);

    window.addEventListener('gamemonetize_event_SDK_GAME_START', onComplete);
    sdk?.showBanner();
    // adinplay
  } else if(windowAny?.adProvider === 'adinplay' && typeof windowAny?.aipPlayer !== 'undefined') {
    console.log('Playing video ad from adinplay');

    /* if (typeof aiptag.adplayer !== "undefined") {
            this.nameBox.getChildByName("btn").innerHTML = "Connecting..";
            this.nameBox.getChildByName("btn").style.backgroundColor = "grey";
            this.music.stop();

            aiptag.cmd.player.push(() => {
              aiptag.adplayer = new aipPlayer({
                AD_WIDTH: 960,
                AD_HEIGHT: 540,
                AD_FULLSCREEN: true,
                AD_CENTERPLAYER: false,
                LOADING_TEXT: "loading advertisement",
                PREROLL_ELEM: function() { return document.getElementById("preroll"); },
                AIP_COMPLETE: (evt) => {
                  // ******************
                  //  ***** WARNING *****
                  //  *******************
                  //  Please do not remove the PREROLL_ELEM
                  //  from the page, it will be hidden automaticly.
                  //  If you do want to remove it use the AIP_REMOVE callback.

                   console.log("preroll complete", evt);
                   this.nameBox.destroy();
                   document.getElementById("game").focus();
                   let failed= false;
                   try {
                     const urlParams = new URLSearchParams(window.location.search);
                     const ad = urlParams.get('debugAd');
                     if(ad) {
                       alert(evt+ " ad completed");
                     }
                   } catch (e) {
                     console.log("failed to get url params");
                   }
                   if(evt == "video-ad-empty" || evt == "user-has-adblock") failed = true;
                   // if(evt == "user-has-adblock") alert("Hi, we noticed you are using adblock on swordbattle.io.\n\n As a heavy adblock user myself, I understand the frustration of ads.\n However, as a free game we rely on ads for servers and development cost.\n If you would like to support us, please consider disabling adblock on swordbattle.io to remove this message.\n Thanks!\n- Gautam, lead dev @ swordbattle.io");
                   this.callback(myName, this.music, this.secret, failed);
 document.getElementById("90pxadstyle").innerHTML = `
 #swordbattle-io_970x90 > div > iframe,
 #swordbattle-io_970x90 > iframe {
 bottom: 0px;
     left: 50%;
 transform: translateX(-50%);
 }`;
                   document.getElementById("swordbattle-io_970x250").style.display = "none";
                   document.getElementById("swordbattle-io_970x90").style.display = "none";

                   this.lastAdRef = Number.MAX_SAFE_INTEGER;

                   console.log("Preroll Ad Completed: " + evt);
                 }
               });
             });
             aiptag.cmd.player.push(() => {
               console.log("starting preroll");
               aiptag.adplayer.startPreRoll();
             });
           }
           */

    runAdinplayAd(windowAny, false, (evt) => {
      console.log('[ads] preroll finished:', evt);
      const played = evt === 'video-ad-completed' || evt === 'video-ad-skipped';
      if (played) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('debugAd')) {
          console.log('debugAd=true, not resetting lastVidAdTime');
        } else {
          windowAny.lastVidAdTime = Date.now();
          window.localStorage.setItem('lastVidAdTime', windowAny.lastVidAdTime);
        }
      }
      resolve({ played: evt === 'video-ad-completed', evt });
    });
  } else if(windowAny?.adProvider === 'gamepix' && windowAny?.GamePix) {
    windowAny?.GamePix.interstitialAd().then(function (res: any) {
      console.log('Ad closed', res);
      resolve({ played: true, evt: 'gamepix-closed' });
    }).catch(function () {
      resolve({ played: false, evt: 'gamepix-error' });
    });
  } else {
    console.log('Adprovider is', windowAny?.adProvider, 'not playing video ad');
    resolve({ played: false, evt: 'no-provider' });
  }
} else {
  console.log('Not playing video ad, last ad was', ((Date.now() - windowAny?.lastVidAdTime)/1000).toFixed(2), 's ago');
  resolve({ played: false, evt: 'throttled' });
}
});
}

export const playRewardedAd = () => {
  const windowAny = window as any;
  return new Promise<{ success: boolean; evt: string }>((resolve, reject) => {
    // basic launch
    if(crazygamesSDK.shouldUseSDK()) { resolve({ success: true, evt: 'cg-basic' }); return; }
    if (windowAny?.adProvider === 'adsense') {
      console.warn('[ads] playRewardedAd is not supported on adsense, use armAdsenseReward');
      resolve({ success: false, evt: 'rewarded-needs-arm' });
      return;
    }
    if(windowAny?.adProvider === 'crazygames') {
      console.log('Playing rewarded ad from CrazyGames');

      crazygamesSDK.requestAd('rewarded', {
        adStarted: () => {
          console.log('[CrazyGames] Rewarded ad started');
          const event = new CustomEvent('crazyGamesAdStarted');
          window.dispatchEvent(event);
        },
        adFinished: () => {
          console.log('[CrazyGames] Rewarded ad finished - user should receive reward');
          const event = new CustomEvent('crazyGamesAdFinished');
          window.dispatchEvent(event);
          resolve({ success: true, evt: 'rewarded-granted' });
        },
        adError: (error) => {
          console.log('[CrazyGames] Rewarded ad error:', error);
          const event = new CustomEvent('crazyGamesAdFinished');
          window.dispatchEvent(event);

          // Don't give reward if ad failed
          resolve({ success: false, evt: 'video-ad-error' });
        }
      });
    } else if (windowAny?.adProvider === 'adinplay' && typeof windowAny?.aipPlayer !== 'undefined') {
      console.log('Playing rewarded ad from adinplay');
      const startedAt = Date.now();
      runAdinplayAd(windowAny, true, (evt) => {
        if (evt === 'rewarded-not-granted' && Date.now() - startedAt < rewardedFastFailMs) {
          console.log('[ads] no rewarded placement, falling back to preroll');
          runAdinplayAd(windowAny, true, (evt2) => {
            const success = evt2 === 'video-ad-completed';
            console.log('[ads] rewarded-fallback preroll result:', evt2, '-> success:', success);
            resolve({ success, evt: evt2 });
          }, true);
          return;
        }
        const success = evt === 'video-ad-completed' || evt === 'rewarded-granted';
        console.log('[ads] rewarded result:', evt, '-> success:', success);
        resolve({ success, evt });
      });
    } else {
      console.log('Rewarded ads not supported for provider:', windowAny?.adProvider);
      resolve({ success: false, evt: 'no-provider' });
    }
  });
}

export async function generateInviteLink(params?: InviteParams): Promise<string | null> {
  try {
    const defaultParams: InviteParams = {
      timestamp: Date.now(),
      ...params
    };

    const result = await crazygamesSDK.getInviteLink(defaultParams);

    if (result && result.inviteUrl) {
      console.log('[Invite] Generated invite link:', result.inviteUrl);
      return result.inviteUrl;
    }

    return null;
  } catch (error) {
    console.error('[Invite] Error generating invite link:', error);
    return null;
  }
}
